import { create } from 'zustand';
import { UIConfig } from '../types/whiteboardProps';

interface TestMetadataStore {
  testId: string | null;
  testType: number | null;
  testSettings: {
    // Backend'den gelecek ayarlar
    allowRecording?: boolean;
    allowExport?: boolean;
    showOpticalForm?: boolean;
    showSolutionViewing?: boolean;
    maxRecordingDuration?: number;
    recordingQuality?: 'low' | 'medium' | 'high';
    // Daha fazla ayar eklenebilir
  };
  uiConfig: UIConfig | null;
  
  // Actions
  setTestMetadata: (testId: string, testData: {
    testType?: number;
    testSettings?: TestMetadataStore['testSettings'];
    uiConfig?: UIConfig;
  }) => void;
  
  getUIConfig: () => UIConfig | null;
  
  clearTestMetadata: () => void;
}

export const useTestMetadataStore = create<TestMetadataStore>((set, get) => ({
  testId: null,
  testType: null,
  testSettings: {},
  uiConfig: null,
  
  setTestMetadata: (testId, testData) => {
    set({
      testId,
      testType: testData.testType ?? null,
      testSettings: testData.testSettings ?? {},
      uiConfig: testData.uiConfig ?? null,
    });
  },
  
  getUIConfig: () => {
    return get().uiConfig;
  },
  
  clearTestMetadata: () => {
    set({
      testId: null,
      testType: null,
      testSettings: {},
      uiConfig: null,
    });
  },
}));